// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiple-row-action{height:60px;background:#fafafa;border-top:2px solid #ddd;justify-content:space-between}.multiple-row-action,.multiple-row-action .selection{display:flex;align-items:center}.multiple-row-action .select-all-cb{margin-left:1.5em}.multiple-row-action .action,.multiple-row-action .selection-count{margin:0 24px}.multiple-row-action .selection-count{font-size:18px;color:#adadad}", ""]);
// Exports
module.exports = exports;
